<template>
  <b-modal :visible="value" title="Duplicate Course" size="md" hide-footer centered @hidden="handleHidden">
    <b-form-group label="Title" label-for="duplicate-title" label-class="form-label">
      <b-form-input id="duplicate-title" v-model="form.title" placeholder="Enter new course title" required />
    </b-form-group>
    <b-form-group label="Program Category" label-for="duplicate-program" label-class="form-label">
      <v-select
        id="duplicate-program"
        class="form-control v-select-custom"
        label="title"
        v-model="form.program_category"
        :reduce="pg => pg.id"
        placeholder="Select Program Category"
        :options="allPrograms"
        :loading="areProgramsLoading"
      >
      </v-select>
    </b-form-group>
    <div class="text-right">
      <b-button variant="secondary" class="mr-2" :disabled="isLoading" @click="cancel">
        Cancel
      </b-button>
      <b-button variant="primary" :disabled="isConfirmDisabled" @click="confirm">
        <b-spinner small v-if="isLoading" class="mr-2" />
        <span v-else>Duplicate</span>
        <span v-if="isLoading">Duplicating...</span>
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'DuplicateCourseModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    initialTitle: {
      type: String,
      default: '',
    },
    initialProgramCategory: {
      type: [Number, String, null],
      default: null,
    },
    allPrograms: {
      type: Array,
      default: () => [],
    },
    areProgramsLoading: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        title: this.initialTitle,
        program_category: this.initialProgramCategory,
      },
    };
  },
  computed: {
    isConfirmDisabled() {
      return this.isLoading || !this.form.title || !this.form.program_category;
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.resetForm();
      }
    },
    initialTitle() {
      if (this.value) this.resetForm();
    },
    initialProgramCategory() {
      if (this.value) this.resetForm();
    },
  },
  methods: {
    resetForm() {
      this.form = {
        title: this.initialTitle,
        program_category: this.initialProgramCategory,
      };
    },
    handleHidden() {
      this.$emit('input', false);
      this.$emit('hidden');
    },
    cancel() {
      this.$emit('input', false);
      this.$emit('cancel');
    },
    confirm() {
      if (this.isConfirmDisabled) return;
      this.$emit('confirm', { ...this.form });
    },
  },
};
</script>
